import React from "react";
import { Button } from "../../../Button";
import { Link } from "react-router-dom";

function ProductCard({ productImg, productTitle, productDetails, productLink, buttonLabel }) {
  return (
    <div className="home__product-container">
      <div className="home__image-container">
        <img
          alt={`herby-snacks-${productTitle.toLowerCase().replace(" ", "-")}-product`}
          className="home__product-image"
          src={productImg}
        ></img>
      </div>
      <div className="home__product-bottom-container">
        <div className="home__product-text-wrapper">
          <div className="home_product-title">{productTitle}</div>
          <div className="home__product-description">
            {productDetails}
          </div>
        </div>
        <div className="home__product-button-container">
          <Link to={productLink}>
            <Button
              shadow={true}
              buttonSize="btn--wide"
              buttonColor="gradient-orange"
            >
              {buttonLabel}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProductCard; 